module.exports = "<button class=\"gw-btn\" ng-click=\"gotBackToHomeState()\">\n    {{'fnol.common.views.confirmation.Back to Homepage'|translate}}\n</button>"